module.exports = __webpack_public_path__ + "img/Content.ef174fdf.png";